import { useContext, useMemo } from 'react';
import { ControlledDateTimePickerContext } from '../../ControlledDateTimePickerCTX.js';
import { deconstructValuesFromDateString } from '../stringHelpers.js';
import type { DSControlledDateTimePickerInternalsT } from '../../sharedTypes.js';

export const useGetMonthYearFromDateStringOrEmptyStartingMonth = (): {
  year: number;
  month: DSControlledDateTimePickerInternalsT.DateMonth;
} => {
  const { dateStringFromProps, emptyPickerStartingMonth } = useContext(ControlledDateTimePickerContext);

  return useMemo(() => {
    const { month: stringMonthVal, year: stringYearVal } = deconstructValuesFromDateString(dateStringFromProps);

    const { month: emptyStringSplitMonth, year: emptyStringSplitYear } =
      deconstructValuesFromDateString(emptyPickerStartingMonth);
    const userEmptyStringMonth = Number.parseInt(emptyStringSplitMonth, 10);
    const userEmptyStringYear = Number.parseInt(emptyStringSplitYear, 10);

    const month: DSControlledDateTimePickerInternalsT.DateMonth =
      stringMonthVal === '' || stringMonthVal.length !== 2
        ? ((userEmptyStringMonth - 1) as DSControlledDateTimePickerInternalsT.DateMonth)
        : ((Number.parseInt(stringMonthVal, 10) - 1) as DSControlledDateTimePickerInternalsT.DateMonth); // month is 0~11 in javascript Date...

    const year = stringYearVal === '' ? userEmptyStringYear : Number.parseInt(stringYearVal, 10);

    return { year, month };
  }, [dateStringFromProps, emptyPickerStartingMonth]);
};
